import styles from './login3.module.css';

// The React Functional Component
export const Login3 = () => {
  // You would handle the password visibility state and form submission here

  const DEFAULT_IMAGES = [
  {
    src: 'https://images.unsplash.com/photo-1755331039789-7e5680e26e8f?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    alt: 'Abstract art'
  },
  {
    src: 'https://images.unsplash.com/photo-1755569309049-98410b94f66d?q=80&w=772&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    alt: 'Modern sculpture'
  },
  {
    src: 'https://images.unsplash.com/photo-1755497595318-7e5e3523854f?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    alt: 'Digital artwork'
  },
  {
    src: 'https://images.unsplash.com/photo-1755353985163-c2a0fe5ac3d8?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    alt: 'Contemporary art'
  },
  {
    src: '/pic1.jpg',
    alt: ''
  },
  {
    src: 'https://images.unsplash.com/photo-1752588975228-21f44630bb3c?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    alt: 'Textured surface'
  },
  { src: '/pic2.jpg',
     alt: '' }
];


  return (
    // Wrapper and Layout Containers (similar to LoginSplit)
    <div className={`${styles.root} light`}>
      <div className={styles.container}>
          {/* Left Column: Image */}
        <div className={styles.imageSection}>
          <img 
            className={styles.image} 
            alt="A serene beach with turquoise water, white sand, and lush green palm trees under a clear blue sky, viewed from above." 
            src='/pic1.jpg'
          />
          <div className={styles.imageOverlay}></div>
        </div>
        
        {/* right Column: Form Content */}
        <div className={styles.formSection}>
          <div className={styles.formWrapper}>
            
         
            
            <main className={styles.mainContent}>
              <div className={styles.titleGroup}>
                <p className={styles.title}>Create Your Account</p>
                <p className={styles.subtitle}>Start planning your next adventure today.</p>
              </div>
              
              <form className={styles.form} onSubmit={(e) => e.preventDefault()}>
                
                {/* Full Name Field */}
                <label className={styles.formGroup}>
                  <p className={styles.label}>Full Name</p>
                  <input className={styles.input} placeholder="e.g., Alex Doe" type="text" defaultValue="" />
                </label>
                
                {/* Email Field */}
                <label className={styles.formGroup}>
                  <p className={styles.label}>Email Address</p>
                  <input className={styles.input} placeholder="e.g., alex.doe@example.com" type="email" defaultValue="" />
                </label>
                
                {/* Password Field */}
                <label className={styles.formGroup}>
                  <p className={styles.label}>Password</p>
                  <div className={styles.inputStretchWrapper}>
                    <input 
                      className={styles.passwordInput} 
                      placeholder="Enter a secure password" 
                      type="password" 
                      defaultValue="" 
                    />
                    <div className={styles.passwordIconWrapper}>
                      {/* Note: The original HTML showed 'visibility' which means visible, so I've kept it as is */}
                      <span className="material-symbols-outlined text-xl">visibility</span>
                    </div>
                  </div>
                </label>
                
              
                
                {/* Submit Button */}
                <button className={styles.registerButton} type="submit">
                  <span className={styles.buttonText}>Create Account</span>
                </button>
              </form>
              
              {/* Sign In Link */}
              <p className={styles.signInText}>
                Already have an account? <a className={styles.signInLink} href="#">Sign In</a>
              </p>
            </main>

          </div>
        </div>

      {DEFAULT_IMAGES.map((img, index)=>
    <div key={index}>
    <img src={img.src} alt={img.alt} style={{height: '200px', width: 'auto', objectFit: 'cover'}} />
    <p>this is pic {index + 1}</p>
    
    </div>)}
        
      </div>
    </div>
  );
};